/**
 * mixin 全局的 toast
 */
import Vue from 'vue'
import util from './util'
import cache from './cache'
Vue.mixin({
  computed: {
    isZS () {
      return !this.$store.state.isDOS
    },
    // 是否查看平台参考价
    canViewReferPrice () {
      return this.$store.state.canViewReferPrice
    },
    storesConfig () {
      return this.$store.state.stores_config
    },
    customized () {
      return this.$store.state.customized
    }
  },
  methods: {
    shareFriend (options, hasParams = true) {
      let customized = this.$store.state.customized
      if (!customized) return

      let url = window.location.href
      const formId = cache.getSessionData('formId')

      if (!(url.includes('_from_store_id') && url.includes('_from_corp_id'))) {
        const urlJoin = hasParams ? `${url}&` : `${url}?`
        url = `${urlJoin}_from_store_id=${customized.store_config.store_id}&_from_corp_id=${formId}`
      }

      let opt = {
        title: options.title,
        desc: options.desc,
        link: url,
        imgUrl: options.imgUrl
      }
      this.$wechat.promise.then(wx => {
        wx.shareAppMessage(opt)
        // wx.shareWechat(opt)
      }, wx => {
        // 抛出异常
        throw new Error(`微信JSSDK校验错误:${JSON.stringify(wx.res)}`)
      })
    },
    showToast(text, type = 'text') {
      util.showToast(text, type)
    },
    switchLoading(loading) {
      this.$store.dispatch('UPDATE_LOADING', {
        status: loading.status || false,
        text: loading.text || '',
        time: loading.time || 0
      })
    },
    runBack(num = -1) {
      this.$router.go(num)
    }
  },
  filters: {
    /**
     * 分转成元（保留两个小数）
     * @param {number} val 金额（分）
     */
    transformMoney(val) {
      if (val !== null && val !== undefined) {
        return (parseInt(val) / 100).toFixed(2)
      } else {
        return '--'
      }
    },
    /**
     * 分转成元（无小数）
     * @param {number} val 金额（分）
     */
    transformMoneyNoDecimal(val) {
      // null和undefined判断（不能直接判断val是否为true，金额可能为0）
      if (val !== null && val !== undefined) {
        return (parseInt(val) / 100).toFixed(0)
      } else {
        return '--'
      }
    }
  }
})
